// Origen del backend (sin /api). Normalizar barra final para evitar //api en la URL.
const rawApiOrigin = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/+$/, '');
export const baseUrlCSRFCookie = rawApiOrigin;
export const baseUrl = `${rawApiOrigin}/api`;

/**
 * Prefijo de ruta donde está montada la SPA (ej. '' si la URL es /#/..., '/smile' si es /smile/#/...).
 * Sirve para armar URLs con hash en window.open sin usar process en runtime (evita errores con SES/extensiones).
 */
export function getSpaPathPrefix() {
    if (typeof window === 'undefined') return '';
    return window.location.pathname.replace(/\/$/, '');
}